import { installSetupForms } from "./features/setup/forms.js";
import { installSiteEvents } from "./features/sites/create-site.js";
import { installCutoffEvents } from "./features/payroll/cutoff-form.js";
import { installWorkspaceTools } from "./features/admin/workspace-tools.js";
import { installEmployeeEvents } from "./features/people/profile.js";
import { installStatutoryEvents } from "./features/statutory/page.js";
import { installWorkLogEvents } from "./features/work-logs/page.js";
import { installHrmEvents, loadHrm } from "./features/hrm/foundation.js";
import "@fontsource-variable/inter/wght.css";
import "./styles/work-logs.css";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/layout.css";
import "./styles/ui.css";
import "./styles/tables.css";
import "./styles/reporting.css";
import "./styles/overview.css";
import "./styles/date-picker.css";
import "./styles/auth.css";
import "./styles/invoices.css";
import "./styles/forms.css";
import "./styles/payroll.css";
import "./styles/settings.css";
import "./styles/hrm.css";
import "./features/overview/page.js";
import "./features/accounting/page.js";
import "./features/invoices/page.js";
import "./features/deployments/page.js";
import "./features/people/page.js";
import "./features/reporting/page.js";
import "./features/sites/page.js";
import "./features/projects/page.js";
import "./features/leave/page.js";
import "./features/payroll/page.js";
import "./features/self-service/page.js";
import "./features/admin/page.js";
import "./features/accounts/page.js";
import {
  installSettingsEvents,
  refreshAccountInfo,
} from "./features/settings/page.js";
import "./features/audit/page.js";
import { ui } from "./app/store.js";
import { render } from "./app/shell.js";
import { installControllers } from "./app/controllers.js";
import { installCalendarEvents } from "./app/calendar-events.js";
import { installTableFormatting } from "./components/tables.js";
import {
  request,
  loadWorkspace,
  scheduleSave,
  hasUnsavedChanges,
} from "./services/api.js";
import { installAuthEvents } from "./features/auth-page.js";
import { capturePasswordReset } from "./features/password-security.js";
import {
  captureInvitation,
  inspectInvitation,
} from "./features/invitation-page.js";
import { installCapitalization } from "./components/capitalization.js";
import { installCreationFlows } from "./components/creation-flow.js";
import { installCookieNotice } from "./components/cookie-notice.js";
installCapitalization();
installCreationFlows();
installCookieNotice();
installAuthEvents();
installSetupForms();
installStatutoryEvents();
installSiteEvents();
installCutoffEvents();
installWorkspaceTools();
installSettingsEvents();
installEmployeeEvents();
installWorkLogEvents();
installHrmEvents();
installCalendarEvents();
installControllers();
installTableFormatting();
globalThis.addEventListener("milltech:save", scheduleSave);
globalThis.addEventListener("milltech:render", render);
let toastTimer;
globalThis.addEventListener("milltech:sync", () => {
  if (!ui.syncStatus || ui.syncStatus === "Saving…") return;
  let node = document.getElementById("sync-toast");
  if (!node) {
    node = document.createElement("div");
    node.id = "sync-toast";
    node.className = "sync-toast";
    node.setAttribute("role", "status");
    document.body.append(node);
  }
  node.textContent = ui.syncStatus;
  node.classList.toggle("error", !!ui.syncError);
  node.classList.add("show");
  clearTimeout(toastTimer);
  toastTimer = setTimeout(
    () => node.classList.remove("show"),
    ui.syncError ? 6000 : 2200,
  );
});
window.addEventListener("beforeunload", (event) => {
  if (hasUnsavedChanges()) {
    event.preventDefault();
    event.returnValue = "";
  }
});
window.addEventListener("hashchange", () => {
  if (ui.user) {
    ui.view = location.hash.slice(1) || "overview";
    render();
    if (["people", "worklogs", "payroll", "leave"].includes(ui.view)) void loadHrm().then(render).catch(() => {});
    if (ui.view === "settings") void refreshAccountInfo();
  }
});
try {
  const invitationActive = captureInvitation();
  const passwordResetActive = !invitationActive && capturePasswordReset();
  const publicConfig = await request("/api/public-config");
  ui.turnstileSiteKey = publicConfig.turnstileSiteKey;
  ui.workspaceMode = publicConfig.mode;
  if (invitationActive) {
    render();
    await inspectInvitation();
  } else if (passwordResetActive) {
    render();
  } else {
    const session = await request("/api/session");
    ui.setupRequired = session.setupRequired;
    ui.setupProtected = session.setupProtected;
    ui.setupMethod = session.setupMethod;
    ui.mfaEnrollmentRequired = !!session.mfaEnrollmentRequired;
    ui.securityUser = session.securityUser;
    ui.mfaEnabled = !!session.mfaEnabled;
    ui.workspaceMode = session.mode;
    if (session.user && !ui.mfaEnrollmentRequired) {
      await loadWorkspace();
      await loadHrm();
      ui.view = location.hash.slice(1) || "overview";
      if (ui.view === "settings") await refreshAccountInfo({ render: false });
    }
    render();
  }
} catch (error) {
  document.getElementById("root").innerHTML =
    '<main class="login"><h1>Milltech could not open</h1><p id="startup-error"></p><button id="startup-retry">Try again</button></main>';
  document.getElementById("startup-error").textContent = error.message;
  document
    .getElementById("startup-retry")
    .addEventListener("click", () => location.reload());
}
